import 'babel-polyfill'

import * as ReactUtils from './ReactUtils'

$(document).on("wheel", "input[type=number]", function (e) {
    $(this).blur();
});

$.fn.extend({
    findParentByComponent: function (targetComponent) {
        let element = $(this)
        let targetComponentName = targetComponent.name

        while (element) {
            let component = element.data('__component')
            if (component === targetComponentName) {
                return element
            }

            element = element.parent()
            if (element.length === 0) {
                break
            }
        }

        return null
    },

    findChildrenByComponent: function (targetComponent) {
        let element = $(this)
        let children = element.children()
        let targetComponentName = targetComponent.name
        let result = []

        children.each((idx, child) => {
            child = $(child)

            let component = child.data('__component')
            if (component === targetComponentName) {
                result.push(child.data('__componentInstance'))
            }
        })

        return result
    },

    forEach: function (itemCallback) {
        if (!itemCallback || !this.length || !this.prevObject) {
            return
        }

        for (let i = 0; i < this.length; i++) {
            itemCallback($(this[i]), i)
        }
    },

    getComponent: function () {
        return this.data('__componentInstance')
    },

    getComponentClassName: function () {
        return this.data('__component')
    },

    getReactComponent: function () {
        return ReactUtils.findReactInstance(this[0])
    },

    toJQueryObjectsArray: function () {
        let result = []

        this.each((idx, item) => {
            result.push($(item))
        })

        return result
    }
})

export default class JQueryRegistry {
    static entries = {}

    static add(selector, klass) {
        JQueryRegistry.entries[selector] = klass
    }

    static getEntries() {
        return JQueryRegistry.entries
    }
}

export function initializeJQueryComponent(klass, element) {
    if (element.data('__component') === klass.name) {
        return
    }

    let componentInstance = new klass(element)
    element.data('__component', klass.name)
    element.data('__componentInstance', componentInstance)
    element.trigger('componentloaded', componentInstance)
}

export function registerJQueryComponent(klass, selector) {
    JQueryRegistry.add(selector, klass)

    $(document).ready(() => {
        $(selector).toJQueryObjectsArray().forEach(item => {
            initializeJQueryComponent(klass, item)
        })
    })
}
